export const getTokenFragment = () => `token {
    id
    parentId
}`
